<template>
  <div class="project-grid" ref="grid">
    <article
      v-for="(project, index) in projects"
      :key="index"
      ref="items"
      class="project-grid--item"
      @mouseover="playVideo"
      @mouseleave="stopVideo"
    >
      <router-link :to="project.url ? project.url : '/'">
        <div class="project-grid--item__image">
          <div class="image-wrapper">
            <!-- @/assets/lonely-astronaut-in-dark-forest-video.mp4 -->
            <!-- :src="
								project.posterVideo
									? project.posterVideo
									: '@/assets/lonely-astronaut-in-dark-forest-video.mp4'
							" -->
            <video
              :src="project.posterVideo ? project.posterVideo : defaultVideo"
              :poster="project.posterImage"
              loop
              muted
              width="413"
              height="516"
            ></video>
            <!-- :poster="project.posterImage" -->
          </div>
        </div>
        <div class="project-grid--item__content">
          <Heading :text="project.name" type="h5" spaced />
          <Heading :text="project.type" type="h6" class="eyebrow" />
          <p>
            {{ project.excerpt }}
          </p>
        </div>
      </router-link>
    </article>
  </div>
</template>

<script>
import VanillaTilt from "vanilla-tilt";
import Heading from "@/components/Heading";
import projects from "@/data/projects.js";
import defaultVideo from "@/assets/lonely-astronaut-in-dark-forest-video.mp4";

export default {
  name: "ProjectGrid",
  components: {
    Heading,
  },
  data() {
    return {
      projects,
      defaultVideo,
    };
  },
  mounted() {
    const tilt = document.querySelectorAll(".project-grid--item a");
    VanillaTilt.init(tilt, {
      max: 5,
      speed: 1000,
    });
  },
  methods: {
    playVideo(e) {
      const vid = e.currentTarget.querySelector("video");
      if (vid) {
        vid.play();
      }
    },
    stopVideo(e) {
      const vid = e.currentTarget.querySelector("video");
      if (vid) {
        vid.pause();
        vid.currentTime = 0;
      }
    },
  },
};
</script>

<style></style>
